<template lang="pug">
.v-page-footer-info.page-footer__cell(v-if="footer" )
	.page-footer__block.page-footer__block-center.flc(v-if="footer.info" )
		template(v-if="footer.info.email" )
			a.page-footer__link.h2(v-if="footer.info.email.href && footer.info.email.text" :href="`mailto:${footer.info.email.href}`") {{ footer.info.email.text }}
		.page-footer__block-body.flc
			.contact-link-block.contact-link-block--icons(v-if="footer.links" )
				template(v-for="(link, index) in footer.links" :key="index" )
					a(:href="link.href")
						v-svg-icon.contact-link-block__icon(:icon="link.icon")
			template(v-if="footer.info.buttons")
				.contact-link-block.fllc(v-for="(button, index) in footer.info.buttons" :key="index")
					a.contact-link-button(:class="button.className, {'js-open-modal': button.modalLink || button.modalData}" :type="button.type"
						:data-modal-url="button.modalLink"
						:data-modal-data="button.modalData"
						:href="button.link"
						@click="itemClick(button, $event)"
						) {{ button.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			footer: {}
		};
	},

	methods: {
		dataSet(data) {
			this.footer = data;
		},

		itemClick(item, e) {
			if (!this.touch) {
				return;
			}
			if (this.openMenuId !== item.menuId && item.items && item.items.length) {
				e.preventDefault();
				this.openMenuId = item.menuId;
			} else {
				this.openMenuId = null;
			}
		},
	}
};
</script>
